import TransferOrganizationModal from './TransferOrganizationModal';

export default TransferOrganizationModal;
